module.exports = __webpack_public_path__ + "static/laser-6aa94efccf9ed076930711ccb835f916.webp";